import { useSelector } from "react-redux";
import { Organisation } from "../../../../models/Organisation";
import { ApplicationState } from "../../../../store";
import { useGetUserGroupsQuery } from "../../../../store/api/kinesense";
import { User } from "../../../../models/User";
import { Accordion, Container } from "react-bootstrap";
import { AddUserGroupButton } from "./AddUserGroupButton";
import ConditionalSpinner from "../../../../components/ConditionalSpinner";
import { UserGroupDetails } from "./UserGroupDetails";

export interface UserGroupsProps {
    organisation: Organisation;
}

export function UserGroups(props: UserGroupsProps) {
    const user = useSelector((state: ApplicationState) => state.user);
    const { data: userGroups, isLoading } = useGetUserGroupsQuery();

    const canCreateGroups = User.can(user.permissions.permissions, "create", "groups");

    return (
        <Accordion flush style={{ width: "100%" }}>
            <Container className="px-0 mb-2 d-flex justify-content-between">
                <h5 className="mb-0">User Groups</h5>
                {canCreateGroups && <AddUserGroupButton {...props} />}
            </Container>

            <ConditionalSpinner isLoading={isLoading}>
                {userGroups?.map((group) => (
                    <Accordion.Item key={group.groupId} eventKey={group.groupId}>
                        <Accordion.Header>{group.name}</Accordion.Header>
                        <Accordion.Body className="ps-5" style={{ width: "100%" }}>
                            <UserGroupDetails key={group.groupId} group={group} />
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </ConditionalSpinner>
        </Accordion>
    );
}
